export enum CatalogSource {
  UNKNOWN = 'unknown',
  USSF = 'spacetrack',
  CELESTRAK = 'celestrak',
  CELESTRAK_SUP = 'celestrak-sup',
  UNIV_OF_MICH = 'univ-of-mich',
  CALPOLY = 'calpoly',
  NUSPACE = 'nuspace',
  VIMPEL = 'vimpel',
  SATNOGS = 'satnogs',
  TLE_TXT = 'TLE.txt',
  EXTRA_JSON = 'extra.json'
}
